var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#A6B6C5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19995 2.40002C2.09538 2.40002 1.19995 3.29546 1.19995 4.40003V8.64001H2.06805C2.02382 8.762 1.99976 8.89328 1.99976 9.03004C1.99976 9.67621 2.53701 10.2 3.19976 10.2C3.8625 10.2 4.39976 9.67621 4.39976 9.03004C4.39976 8.89328 4.37569 8.762 4.33146 8.64001H7.66844C7.62421 8.762 7.60015 8.89328 7.60015 9.03004C7.60015 9.67621 8.1374 10.2 8.80015 10.2C9.46289 10.2 10.0001 9.67621 10.0001 9.03004C10.0001 8.89327 9.97608 8.76199 9.93185 8.63999H10.8001V7.07999H8.39995V7.07995H10.8001V5.51996C10.8001 4.65839 10.0838 3.95996 9.20015 3.95996H8.35138C8.1509 3.0671 7.35333 2.40002 6.39995 2.40002H3.19995ZM9.99995 6.29999H8.39995V4.74H9.19995C9.64178 4.74 9.99995 5.08921 9.99995 5.51999V6.29999ZM3.1983 8.64001H3.2014C3.4216 8.64082 3.59985 8.81511 3.59985 9.03C3.59985 9.24539 3.42077 9.42 3.19985 9.42C2.97894 9.42 2.79985 9.24539 2.79985 9.03C2.79985 8.81511 2.9781 8.64082 3.1983 8.64001ZM8.39995 9.03C8.39995 8.81461 8.57904 8.64 8.79995 8.64C9.02086 8.64 9.19995 8.81461 9.19995 9.03C9.19995 9.24539 9.02086 9.42 8.79995 9.42C8.57904 9.42 8.39995 9.24539 8.39995 9.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicle);
export default __webpack_public_path__ + "static/media/icon-vehicle.e2044032eda53b2eb96ceaa9feefaddb.svg";
export { ForwardRef as ReactComponent };